(function () {
    'use strict';

    angular
        .module('employeeControllers', ['pascalprecht.translate',
                                        'services.appParam',
                                        'services.supervisorService',
                                        'services.employees',
                                        'services.search',
                                        'services.accessReview',
                                        'services.systemOwnerReview']);
})();
